import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {QuestionnaireTabContentComponent} from '../../questionnaire-tab-content/questionnaire-tab-content.component';
import {BadgeListItem} from '../../../list/badge-list/badge-list.types';
import {AttributeValueChange, ModuleTabForQuestionnaire} from '../../provider-questionnaire.types';
import {TabStatusEnum} from '../../../../tabs/tab-status.model';
import {TabStatusDirective} from '../../../../tabs/tab-status.directive';
import {TabsUnsavedRevealDirective} from '../../../../tabs/tabs-unsaved-reveal.directive';
import {environment} from '../../../../../../environments/environment';

@Component({
  selector: 'app-questionnaire-ec3-tabs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Tab,
    TabList,
    Tabs,
    TabPanels,
    TabPanel,
    QuestionnaireTabContentComponent,
    TranslateDirectusPipe,
    TabStatusDirective,
    TabsUnsavedRevealDirective,
  ],
  templateUrl: './questionnaire-ec3-tabs.component.html',
})
export class QuestionnaireEc3TabsComponent {
  protected readonly twoStageAnswers = environment.aiTemplateAnsweringEnabled;

  moduleTabs = input.required<ModuleTabForQuestionnaire[]>();
  activeModuleTabIndex = input.required<number>();
  activeModuleScTabIndex = input.required<number>();
  moduleTabCompletionStatus = input.required<TabStatusEnum[]>();
  moduleTabsUnsaved = input<boolean[]>([]);
  scTabCompletionStatus = input.required<TabStatusEnum[]>();
  scTabsUnsaved = input<boolean[]>([]);
  badgeListItems = input.required<BadgeListItem[]>();
  canSave = input.required<boolean>();
  isSaving = input.required<boolean>();
  disabled = input<boolean>(false);
  showImportanceScore = input<boolean>(true);

  moduleTabChange = output<number>();
  moduleScTabChange = output<number>();
  attributeValueChange = output<AttributeValueChange>();
  saveClick = output<void>();
}
